import React from 'react';
import { roundFloat } from 'src/core/utils/formater';
import { Button, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';

export const customSummary = [
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'left', word: 'Нийт:' },
  { align: 'right', value: 'huuli_7_1_1' },
  { align: 'right', value: 'huuli_7_1_2' },
  { align: 'right', value: '' },
  { align: 'right', value: 'huuli_7_1_6' },

  { align: 'right', value: 'niit_1_2_3' },
  { align: 'right', value: '' },
  { align: 'right', value: 'emd_ndsh_dun_huuli_7_1_1' },
  { align: 'right', value: 'emd_ndsh_dun_huuli_7_1_6' },
  { align: 'right', value: 'huuli_7_1_4_7' },
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'right', value: 'niit_tatvar_nogduulah_orlogo' },
  { align: 'right', value: 'shatlal' },
  { align: 'right', value: 'huuli_7_1_1_7_1_5_7_1_7' },
  { align: 'right', value: 'orlogo_huleen_avsan_sar' },
  { align: 'right', value: 'huuli_23_1_nogdoh' },
  { align: 'right', value: 'huuli_23_1_niit' },
  { align: 'right', value: 'huuli_7_1_hungulult_daraah' },
  { align: 'right', value: 'huuli_7_1_6_dun' },
  { align: 'right', value: 'shuud_bus_orlogo' },
  { align: 'right', value: 'niit_suutguulsan_alban_tatvar' },
];

export const MulticustomSummary = [
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'left', word: 'Нийт:' },
  { align: 'right', value: 'huuli_7_1_1' },
  { align: 'right', value: 'huuli_7_1_2' },
  { align: 'right', value: 'huuli_7_1_6' },
  { align: 'right', value: 'niit_1_2_3' },
  { align: 'right', value: '' },
  { align: 'right', value: 'emd_ndsh_dun_huuli_7_1_1' },
  { align: 'right', value: 'emd_ndsh_dun_huuli_7_1_6' },
  { align: 'right', value: 'huuli_7_1_4_7' },
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'right', value: 'niit_tatvar_nogduulah_orlogo' },
  { align: 'right', value: 'shatlal' },
  { align: 'right', value: 'huuli_7_1_1_7_1_5_7_1_7' },
  { align: 'right', value: 'orlogo_huleen_avsan_sar' },
  { align: 'right', value: 'huuli_23_1_nogdoh' },
  { align: 'right', value: 'huuli_23_1_niit' },
  { align: 'right', value: 'huuli_7_1_hungulult_daraah' },
  { align: 'right', value: 'huuli_7_1_6_dun' },
  { align: 'right', value: 'shuud_bus_orlogo' },
  { align: 'right', value: 'niit_suutguulsan_alban_tatvar' },
];

const orlogon_turul = {
  0: '0-Шууд бус орлого олгоогүй',
  15.1: '15.1-Үнэ төлбөргүй, эсхүл хөнгөлөлттэй үнээр тээврийн хэрэгслээр үйлчилсэн',
  '15.10': '15.10-Эрс тэс уур амьсгалд ажиллаж амьдарсны нэмэгдэл',
  15.11: '15.11-Адилтгах бусад орлого',
  15.2: '15.2-Орон сууцны ашиглалтын болон түрээсийн зардлын төлбөр, байрны хөлс, түлшний зардлын төлбөр',
  15.3: '15.3-Үзвэр үйлчилгээний олговор',
  15.4: '15.4-Ахуйн үйлчлэгч, жолооч, цэвэрлэгч болон бусад үйлчилгээ үзүүлсний зардлын төлбөр',
  15.5: '15.5-Ажил олгогч эсхүл бусад этгээдэд төлөх өр барагдуулсны төлбөр',
  15.6: '15.6-Арилжааны зээлийн хүүгээс доогуур хүүтэй олгосон зээлийн хүүгийн зөрүү',
  15.7: '15.7-Ажил олгогчийн төлсөн энэ хуулийн 11.2.7-д зааснаас бусад сайн дурын даатгалын хураамж',
  15.8: '15.8-Гэр бүлийн гишүүний сургалтын төлбөр',
  15.9: '15.9-Монгол Улсад нүүж ирэх болон буцахтай холбогдон гарах зардлын төлбөр',
};

export const columns = ({ showEditModal, shouldRenderEditColumn }) => {
  const cols = [
    {
      title: 'Татвар төлөгчийн дугаар',
      dataIndex: 'ttd',
      align: 'center',
      width: 150,
      fixed: 'left',
    },
    {
      title: 'Овог',
      dataIndex: 'ovog',
      align: 'right',
      width: 150,
      className: 'cell-left-border',
    },
    {
      title: 'Нэр',
      dataIndex: 'ner',
      align: 'right',
      width: 150,
    },
    {
      title: 'Хуулийн 7.1.1',
      dataIndex: 'huuli_7_1_1',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хуулийн 7.1.2 7.1.3 7.1.4 7.1.5 7.1.7',
      dataIndex: 'huuli_7_1_2',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хуулийн 7.1.6',
      dataIndex: 'huuli_7_1_6',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Нийт (1+2+3)',
      dataIndex: 'niit_1_2_3',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'ЭМД, НДШ Хувь',
      dataIndex: 'emd_ndsh_huvi',
      align: 'right',
      width: 150,
      render: (_) => `${_}%`,
    },
    {
      title: 'ЭМД, НДШ Дүн (Хуулийн 7,1,1-5, 7,1,7)',
      dataIndex: 'emd_ndsh_dun_huuli_7_1_1',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'ЭМД, НДШ Дүн (Хуулийн 7,1,6)',
      dataIndex: 'emd_ndsh_dun_huuli_7_1_6',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хуулийн 7.1-д заасан орлогод татвар ногдуулах орлого (4-6-7)',
      dataIndex: 'huuli_7_1_4_7',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Орлогын төрөл',
      dataIndex: 'orlogon_turul',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Орлого',
      dataIndex: 'orlogo',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Нийт татвар ногдуулах орлого',
      dataIndex: 'niit_tatvar_nogduulah_orlogo',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Шатлал',
      dataIndex: 'shatlal',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },

    {
      title: 'Хуулийн 7.1.1, 7.1.5, 7.1.7-д заасан орлогод Ногдуулсан татвар',
      dataIndex: 'huuli_7_1_1_7_1_5_7_1_7',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Орлого хүлээн авсан сарын тоо /ажилласан сар/',
      dataIndex: 'orlogo_huleen_avsan_sar',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хуулийн 23.1-т заасан хөнгөлөлт сард ногдох',
      dataIndex: 'huuli_23_1_nogdoh',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хуулийн 23.1-т заасан хөнгөлөлт нийт',
      dataIndex: 'huuli_23_1_niit',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title:
        'Хуулийн 7,1-д заасан орлогод ногдуулсан Хөнгөлөлтийн дараах татварын дүн',
      dataIndex: 'huuli_7_1_hungulult_daraah',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хуулийн 7.1.6-д заасан орлогод ногдуулсан дүн',
      dataIndex: 'huuli_7_1_6_dun',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Шууд бус орлогод ногдуулсан албан татвар',
      dataIndex: 'shuud_bus_orlogo',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Нийт суутгуулсан албан татварын дүн',
      dataIndex: 'niit_suutguulsan_alban_tatvar',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    // more columns...
  ];

  if (shouldRenderEditColumn) {
    const editColumn = {
      title: '',
      dataIndex: 'edit_huuli_7_1_2',
      align: 'center',
      width: 50,
      render: (_, row) => (
        <Tooltip title="Засварлах">
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => showEditModal(row)}
          />
        </Tooltip>
      ),
    };

    // Insert after the huuli_7_1_2 column (index 4)
    cols.splice(5, 0, editColumn); // inserts at position 5
  }

  return cols;
};
